export function viewFitAction() {
  const { t } = useI18n();

  return {
    getTitle: () => t('components.xeokit_viewer.context_menu.view_fit') || 'View Fit',

    doAction: function (context) {
      const viewer = context.viewer;
      const scene = viewer.scene;
      const entity = context.entity;
      viewer.cameraFlight.flyTo(
        {
          aabb: entity.aabb,
          duration: 0.5,
        },
        () => {
          setTimeout(function () {
            scene.setObjectsHighlighted(scene.highlightedObjectIds, false);
          }, 500);
        },
      );
    },
  };
}
